/**
 * @generated SignedSource<<7be884227db1d2c589999ce602a75c7b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CustomContentInput = {
  attribs?: unknown | null;
  row: number;
  type: string;
};
export type articlePageQuery$variables = {
  customContents?: ReadonlyArray<CustomContentInput | null> | null;
  entityId: string;
  entityUuid: string;
};
export type articlePageQuery$data = {
  readonly article: {
    readonly " $fragmentSpreads": FragmentRefs<"articleAcknowledgementGateOverlayArticle" | "articleBaseAdvertisingInfoArticle" | "articleListArticle" | "articleSeoArticle">;
  };
  readonly " $fragmentSpreads": FragmentRefs<"articleSchemaContent">;
};
export type articlePageQuery = {
  response: articlePageQuery$data;
  variables: articlePageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "customContents"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "entityId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "entityUuid"
},
v3 = {
  "kind": "Variable",
  "name": "entityId",
  "variableName": "entityId"
},
v4 = [
  {
    "fields": [
      (v3/*: any*/)
    ],
    "kind": "ObjectValue",
    "name": "filter"
  }
],
v5 = [
  {
    "kind": "Variable",
    "name": "customContents",
    "variableName": "customContents"
  }
],
v6 = {
  "kind": "Variable",
  "name": "entityUuid",
  "variableName": "entityUuid"
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityUuid",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v11 = [
  (v7/*: any*/),
  (v8/*: any*/),
  (v9/*: any*/),
  (v10/*: any*/)
],
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlAlias",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publishedDate",
  "storageKey": null
},
v14 = [
  (v7/*: any*/),
  (v8/*: any*/)
],
v15 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ArticleType",
    "kind": "LinkedField",
    "name": "value",
    "plural": true,
    "selections": (v14/*: any*/),
    "storageKey": null
  }
],
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "headline",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "socialHeadline",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v19 = [
  (v18/*: any*/)
],
v20 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "filter",
      "value": {
        "style": "237x147"
      }
    }
  ],
  "concreteType": "ImageStyle",
  "kind": "LinkedField",
  "name": "style",
  "plural": false,
  "selections": (v19/*: any*/),
  "storageKey": "style(filter:{\"style\":\"237x147\"})"
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "UrlRedirect",
  "kind": "LinkedField",
  "name": "urlRedirect",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "toUrl",
      "storageKey": null
    },
    (v8/*: any*/)
  ],
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "Application",
  "kind": "LinkedField",
  "name": "application",
  "plural": false,
  "selections": (v14/*: any*/),
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sponsorType",
  "storageKey": null
},
v25 = {
  "alias": "articleTypes",
  "args": null,
  "concreteType": "ArticleTypeSegment",
  "kind": "LinkedField",
  "name": "types",
  "plural": true,
  "selections": (v15/*: any*/),
  "storageKey": null
},
v26 = {
  "kind": "InlineFragment",
  "selections": [
    (v24/*: any*/),
    (v25/*: any*/)
  ],
  "type": "Article",
  "abstractKey": null
},
v27 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "type": "AUTHOR_IMAGE"
    }
  }
],
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "disableFollow",
  "storageKey": null
},
v29 = [
  (v28/*: any*/)
],
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "json",
  "storageKey": null
},
v31 = [
  (v30/*: any*/)
],
v32 = {
  "alias": null,
  "args": null,
  "concreteType": "FormattedValue",
  "kind": "LinkedField",
  "name": "description",
  "plural": false,
  "selections": (v31/*: any*/),
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v34 = {
  "kind": "InlineFragment",
  "selections": [
    (v21/*: any*/),
    (v9/*: any*/),
    (v12/*: any*/),
    (v22/*: any*/),
    (v23/*: any*/),
    (v26/*: any*/)
  ],
  "type": "Base",
  "abstractKey": "__isBase"
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isSlideshow",
  "storageKey": null
},
v37 = [
  (v8/*: any*/)
],
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v39 = [
  (v38/*: any*/)
],
v40 = {
  "alias": null,
  "args": null,
  "concreteType": "FormattedValue",
  "kind": "LinkedField",
  "name": "summary",
  "plural": false,
  "selections": (v39/*: any*/),
  "storageKey": null
},
v41 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "style": "768x768"
    }
  }
],
v42 = [
  (v38/*: any*/),
  (v30/*: any*/)
],
v43 = {
  "alias": null,
  "args": null,
  "concreteType": "Newsletter",
  "kind": "LinkedField",
  "name": "relatedNewsletters",
  "plural": true,
  "selections": [
    (v7/*: any*/),
    (v10/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "alternativeName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FormattedValue",
      "kind": "LinkedField",
      "name": "description",
      "plural": false,
      "selections": (v39/*: any*/),
      "storageKey": null
    },
    (v40/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "FormattedValue",
      "kind": "LinkedField",
      "name": "homepageDescription",
      "plural": false,
      "selections": (v39/*: any*/),
      "storageKey": null
    },
    (v8/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "articlePageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "Article",
        "kind": "LinkedField",
        "name": "article",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "articleAcknowledgementGateOverlayArticle"
          },
          {
            "args": (v5/*: any*/),
            "kind": "FragmentSpread",
            "name": "articleListArticle"
          },
          {
            "args": (v5/*: any*/),
            "kind": "FragmentSpread",
            "name": "articleSeoArticle"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "articleBaseAdvertisingInfoArticle"
          }
        ],
        "storageKey": null
      },
      {
        "args": [
          (v3/*: any*/),
          (v6/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "articleSchemaContent"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "articlePageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "Article",
        "kind": "LinkedField",
        "name": "article",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ArticleTypeSegment",
            "kind": "LinkedField",
            "name": "types",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ArticleType",
                "kind": "LinkedField",
                "name": "value",
                "plural": true,
                "selections": (v11/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v12/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Article",
            "kind": "LinkedField",
            "name": "moreOnThisArticles",
            "plural": true,
            "selections": [
              (v7/*: any*/),
              (v13/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SectionSegment",
                "kind": "LinkedField",
                "name": "sections",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Section",
                    "kind": "LinkedField",
                    "name": "value",
                    "plural": true,
                    "selections": (v14/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ArticleTypeSegment",
                "kind": "LinkedField",
                "name": "types",
                "plural": true,
                "selections": (v15/*: any*/),
                "storageKey": null
              },
              (v12/*: any*/),
              (v8/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Image",
                "kind": "LinkedField",
                "name": "images",
                "plural": true,
                "selections": [
                  (v18/*: any*/),
                  (v20/*: any*/)
                ],
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v21/*: any*/),
                  (v9/*: any*/),
                  (v22/*: any*/),
                  (v23/*: any*/),
                  (v26/*: any*/)
                ],
                "type": "Base",
                "abstractKey": "__isBase"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "commentCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "authorLocations",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Author",
            "kind": "LinkedField",
            "name": "authors",
            "plural": true,
            "selections": [
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "location",
                "storageKey": null
              },
              (v10/*: any*/),
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "types",
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v27/*: any*/),
                "concreteType": "Image",
                "kind": "LinkedField",
                "name": "image",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "filter",
                        "value": {
                          "style": "118x118"
                        }
                      }
                    ],
                    "concreteType": "ImageStyle",
                    "kind": "LinkedField",
                    "name": "style",
                    "plural": false,
                    "selections": (v19/*: any*/),
                    "storageKey": "style(filter:{\"style\":\"118x118\"})"
                  }
                ],
                "storageKey": "image(filter:{\"type\":\"AUTHOR_IMAGE\"})"
              },
              (v12/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v21/*: any*/),
                  (v9/*: any*/),
                  (v22/*: any*/),
                  (v23/*: any*/),
                  (v26/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": (v29/*: any*/),
                    "type": "Author",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v29/*: any*/),
                    "type": "Topic",
                    "abstractKey": null
                  }
                ],
                "type": "Base",
                "abstractKey": "__isBase"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "version",
                "value": 2
              }
            ],
            "kind": "ScalarField",
            "name": "advertZone",
            "storageKey": "advertZone(version:2)"
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sentiment",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "contentLock",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Topic",
            "kind": "LinkedField",
            "name": "topics",
            "plural": true,
            "selections": [
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Sponsor",
                "kind": "LinkedField",
                "name": "sponsor",
                "plural": false,
                "selections": [
                  (v21/*: any*/),
                  (v8/*: any*/),
                  (v32/*: any*/),
                  (v10/*: any*/),
                  (v33/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Image",
                    "kind": "LinkedField",
                    "name": "images",
                    "plural": true,
                    "selections": (v19/*: any*/),
                    "storageKey": null
                  },
                  (v7/*: any*/)
                ],
                "storageKey": null
              },
              (v8/*: any*/),
              (v10/*: any*/),
              (v28/*: any*/),
              (v34/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SectionSegment",
            "kind": "LinkedField",
            "name": "sections",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Section",
                "kind": "LinkedField",
                "name": "value",
                "plural": true,
                "selections": (v11/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "FormattedValue",
            "kind": "LinkedField",
            "name": "multimediaEmbed",
            "plural": false,
            "selections": (v31/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Article",
            "kind": "LinkedField",
            "name": "seriesContainer",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              (v16/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "series",
                "plural": true,
                "selections": [
                  (v21/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v16/*: any*/),
                      (v17/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Article",
                        "kind": "LinkedField",
                        "name": "seriesContainer",
                        "plural": false,
                        "selections": [
                          (v16/*: any*/),
                          (v8/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Image",
                        "kind": "LinkedField",
                        "name": "images",
                        "plural": true,
                        "selections": [
                          (v35/*: any*/),
                          (v18/*: any*/),
                          (v36/*: any*/),
                          (v20/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v9/*: any*/),
                          (v12/*: any*/),
                          (v22/*: any*/),
                          (v23/*: any*/),
                          (v26/*: any*/)
                        ],
                        "type": "Base",
                        "abstractKey": "__isBase"
                      }
                    ],
                    "type": "Article",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v37/*: any*/),
                    "type": "Podcast",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v37/*: any*/),
                    "type": "Video",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              (v8/*: any*/),
              (v34/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Glossary",
            "kind": "LinkedField",
            "name": "glossary",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "term",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "translation",
                "storageKey": null
              },
              (v32/*: any*/)
            ],
            "storageKey": null
          },
          (v16/*: any*/),
          (v21/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdDate",
            "storageKey": null
          },
          (v9/*: any*/),
          (v13/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sponsor",
            "storageKey": null
          },
          (v24/*: any*/),
          (v25/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "PaywallType",
            "kind": "LinkedField",
            "name": "paywallTypes",
            "plural": true,
            "selections": (v14/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "flag",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "knowledgeQuestion",
            "storageKey": null
          },
          (v17/*: any*/),
          (v40/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Image",
            "kind": "LinkedField",
            "name": "images",
            "plural": true,
            "selections": [
              {
                "alias": "generic_og",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                      "style": "og_image_scmp_generic"
                    }
                  }
                ],
                "concreteType": "ImageStyle",
                "kind": "LinkedField",
                "name": "style",
                "plural": false,
                "selections": (v19/*: any*/),
                "storageKey": "style(filter:{\"style\":\"og_image_scmp_generic\"})"
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                      "styles": [
                        "og_image_scmp_analysis",
                        "og_image_scmp_explainer",
                        "og_image_scmp_fact_check",
                        "og_image_scmp_debate",
                        "og_image_scmp_live",
                        "og_image_scmp_obituary",
                        "og_image_scmp_opinion",
                        "og_image_scmp_review",
                        "og_image_scmp_series",
                        "og_image_scmp_generic"
                      ]
                    }
                  }
                ],
                "concreteType": "ImageStyle",
                "kind": "LinkedField",
                "name": "styles",
                "plural": true,
                "selections": [
                  (v18/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "style",
                    "storageKey": null
                  }
                ],
                "storageKey": "styles(filter:{\"styles\":[\"og_image_scmp_analysis\",\"og_image_scmp_explainer\",\"og_image_scmp_fact_check\",\"og_image_scmp_debate\",\"og_image_scmp_live\",\"og_image_scmp_obituary\",\"og_image_scmp_opinion\",\"og_image_scmp_review\",\"og_image_scmp_series\",\"og_image_scmp_generic\"]})"
              },
              (v33/*: any*/),
              {
                "alias": null,
                "args": (v41/*: any*/),
                "concreteType": "ImageStyle",
                "kind": "LinkedField",
                "name": "style",
                "plural": false,
                "selections": (v19/*: any*/),
                "storageKey": "style(filter:{\"style\":\"768x768\"})"
              },
              (v36/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "height",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "width",
                "storageKey": null
              },
              (v18/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "disableOffPlatformContent",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "published",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "FormattedValue",
            "kind": "LinkedField",
            "name": "subHeadline",
            "plural": false,
            "selections": (v39/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v5/*: any*/),
            "concreteType": "FormattedValue",
            "kind": "LinkedField",
            "name": "body",
            "plural": false,
            "selections": (v42/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "keywords",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "copyrighted",
            "storageKey": null
          },
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Correction",
            "kind": "LinkedField",
            "name": "corrections",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "FormattedValue",
                "kind": "LinkedField",
                "name": "correction",
                "plural": false,
                "selections": (v39/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "timestamp",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Topic",
                "kind": "LinkedField",
                "name": "topics",
                "plural": true,
                "selections": [
                  (v9/*: any*/),
                  (v43/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Author",
                "kind": "LinkedField",
                "name": "authors",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SocialLink",
                    "kind": "LinkedField",
                    "name": "socialLinks",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "class",
                        "storageKey": null
                      },
                      (v35/*: any*/),
                      (v18/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "bio",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "shortUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Image",
                "kind": "LinkedField",
                "name": "images",
                "plural": true,
                "selections": [
                  (v35/*: any*/),
                  {
                    "alias": "size1200x800",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "filter",
                        "value": {
                          "style": "1200x800"
                        }
                      }
                    ],
                    "concreteType": "ImageStyle",
                    "kind": "LinkedField",
                    "name": "style",
                    "plural": false,
                    "selections": (v19/*: any*/),
                    "storageKey": "style(filter:{\"style\":\"1200x800\"})"
                  },
                  {
                    "alias": "size768x768",
                    "args": (v41/*: any*/),
                    "concreteType": "ImageStyle",
                    "kind": "LinkedField",
                    "name": "style",
                    "plural": false,
                    "selections": (v19/*: any*/),
                    "storageKey": "style(filter:{\"style\":\"768x768\"})"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SectionSegment",
                "kind": "LinkedField",
                "name": "sections",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Section",
                    "kind": "LinkedField",
                    "name": "value",
                    "plural": true,
                    "selections": [
                      (v43/*: any*/),
                      (v12/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v21/*: any*/),
                          (v22/*: any*/),
                          (v23/*: any*/),
                          (v26/*: any*/)
                        ],
                        "type": "Base",
                        "abstractKey": "__isBase"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "FormattedValue",
                "kind": "LinkedField",
                "name": "subHeadline",
                "plural": false,
                "selections": (v31/*: any*/),
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v43/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ArticleTypeSegment",
                    "kind": "LinkedField",
                    "name": "types",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ArticleType",
                        "kind": "LinkedField",
                        "name": "value",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FormattedValue",
                            "kind": "LinkedField",
                            "name": "description",
                            "plural": false,
                            "selections": (v42/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "coverDesktop",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "filter",
                        "value": {
                          "type": "COVER"
                        }
                      }
                    ],
                    "concreteType": "Image",
                    "kind": "LinkedField",
                    "name": "image",
                    "plural": false,
                    "selections": (v19/*: any*/),
                    "storageKey": "image(filter:{\"type\":\"COVER\"})"
                  },
                  {
                    "alias": "coverMobile",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "filter",
                        "value": {
                          "type": "COVER_MOBILE"
                        }
                      }
                    ],
                    "concreteType": "Image",
                    "kind": "LinkedField",
                    "name": "image",
                    "plural": false,
                    "selections": (v19/*: any*/),
                    "storageKey": "image(filter:{\"type\":\"COVER_MOBILE\"})"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Author",
                    "kind": "LinkedField",
                    "name": "authors",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": (v27/*: any*/),
                        "concreteType": "Image",
                        "kind": "LinkedField",
                        "name": "image",
                        "plural": false,
                        "selections": (v19/*: any*/),
                        "storageKey": "image(filter:{\"type\":\"AUTHOR_IMAGE\"})"
                      },
                      {
                        "alias": "authorLarge",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "filter",
                            "value": {
                              "type": "AUTHOR_LARGE"
                            }
                          }
                        ],
                        "concreteType": "Image",
                        "kind": "LinkedField",
                        "name": "image",
                        "plural": false,
                        "selections": (v19/*: any*/),
                        "storageKey": "image(filter:{\"type\":\"AUTHOR_LARGE\"})"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "type": "Article",
                "abstractKey": null
              }
            ],
            "type": "Content",
            "abstractKey": "__isContent"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Section",
                    "kind": "LinkedField",
                    "name": "fullSectionPath",
                    "plural": true,
                    "selections": [
                      (v10/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "type": "Section",
                "abstractKey": null
              }
            ],
            "type": "Base",
            "abstractKey": "__isBase"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": [
          {
            "fields": [
              (v6/*: any*/)
            ],
            "kind": "ObjectValue",
            "name": "filter"
          }
        ],
        "concreteType": "LiveArticle",
        "kind": "LinkedField",
        "name": "liveArticle",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "customTimezone",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "LiveContent",
            "kind": "LinkedField",
            "name": "liveContents",
            "plural": true,
            "selections": [
              (v7/*: any*/),
              (v13/*: any*/),
              (v35/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "FormattedValue",
                "kind": "LinkedField",
                "name": "body",
                "plural": false,
                "selections": (v39/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v8/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "032a39ee61b91635ddbdd413c44c4e65",
    "id": null,
    "metadata": {},
    "name": "articlePageQuery",
    "operationKind": "query",
    "text": "query articlePageQuery(\n  $entityId: String!\n  $entityUuid: String!\n  $customContents: [CustomContentInput]\n) {\n  article(filter: {entityId: $entityId}) {\n    ...articleAcknowledgementGateOverlayArticle\n    ...articleListArticle_4oKxOH\n    ...articleSeoArticle_4oKxOH\n    ...articleBaseAdvertisingInfoArticle\n    id\n  }\n  ...articleSchemaContent_2w8PNF\n}\n\nfragment articleAcknowledgementGateOverlayArticle on Article {\n  entityId\n}\n\nfragment articleActionWidgetArticle on Article {\n  ...articleCommentsTriggerArticle\n  entityId\n  urlAlias\n}\n\nfragment articleAuthorBlockArticle on Article {\n  ...articleDateContent\n  ...authorNamesArticle\n  authors {\n    entityId\n    ...entityFollowButtonBase\n    ...authorAvatarAuthor\n    id\n  }\n}\n\nfragment articleAuthorDetailsContent on Content {\n  __isContent: __typename\n  authors {\n    entityId\n    ...authorCardAuthor\n    bio\n    id\n  }\n}\n\nfragment articleBaseAdvertisingInfoArticle on Article {\n  advertZone(version: 2)\n  entityId\n  sentiment\n  contentLock\n  topics {\n    entityId\n    sponsor {\n      __typename\n      id\n    }\n    id\n  }\n  types {\n    value {\n      entityId\n      id\n    }\n  }\n  sections {\n    value {\n      entityId\n      id\n    }\n  }\n  ...helpersCheckIsMainTopicContent\n}\n\nfragment articleCommentsTriggerArticle on Article {\n  commentCount\n}\n\nfragment articleDateContent on Content {\n  __isContent: __typename\n  createdDate\n  publishedDate\n  updatedDate\n}\n\nfragment articleFooterArticle on Article {\n  ...articleUtilsArticle\n  ...morningStudioArticleFooterContent\n  ...genericArticleFooterArticle\n}\n\nfragment articleImageGalleryContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  shortUrl\n  headline\n  socialHeadline\n}\n\nfragment articleLeadingArticle on Article {\n  multimediaEmbed {\n    json\n  }\n  ...articleLeadingImagesContent\n  ...contentSchemaRenderContent\n}\n\nfragment articleLeadingImagesContent on Content {\n  __isContent: __typename\n  images {\n    title\n    url\n    isSlideshow\n    size1200x800: style(filter: {style: \"1200x800\"}) {\n      url\n    }\n    size768x768: style(filter: {style: \"768x768\"}) {\n      url\n    }\n  }\n}\n\nfragment articleLeftHandSideWidgetsContent on Article {\n  ...seriesWidgetContent\n  ...topPicksWidgetContent\n  seriesContainer {\n    series {\n      __typename\n      ... on Article {\n        id\n      }\n      ... on Podcast {\n        id\n      }\n      ... on Video {\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment articleLinkingDataContent on Content {\n  __isContent: __typename\n  urlAlias\n  sections {\n    value {\n      ...helpersFilterSection\n      ...entityLink\n      name\n      urlAlias\n      id\n    }\n  }\n}\n\nfragment articleListArticle_4oKxOH on Article {\n  ...articleFooterArticle\n  ...articlePaginationCheckerArticle\n  ...articlePaginationNavigationHistoryArticle_4oKxOH\n  ...articleRecommendationArticle\n  ...articlePaywallCheckerArticle\n  ...articleRenderArticle_4oKxOH\n}\n\nfragment articleMoreOnThisListArticle on Article {\n  moreOnThisArticles {\n    ...entityLink\n    entityId\n    headline\n    socialHeadline\n    urlAlias\n    images {\n      url\n      style(filter: {style: \"237x147\"}) {\n        url\n      }\n    }\n    id\n  }\n}\n\nfragment articlePaginationCheckerArticle on Article {\n  ...articleUtilsArticle\n}\n\nfragment articlePaginationNavigationHistoryArticle_4oKxOH on Article {\n  urlAlias\n  ...hooksTrackCurrentItemBase_4oKxOH\n}\n\nfragment articlePaywallCheckerArticle on Article {\n  ...hooksPaywallPromiseArticle\n}\n\nfragment articleRecommendationArticle on Article {\n  entityId\n  moreOnThisArticles {\n    entityId\n    publishedDate\n    sections {\n      value {\n        entityId\n        id\n      }\n    }\n    types {\n      value {\n        entityId\n        id\n      }\n    }\n    urlAlias\n    id\n  }\n}\n\nfragment articleRenderArticle_4oKxOH on Article {\n  entityId\n  ...articleActionWidgetArticle\n  ...articleAuthorBlockArticle\n  ...articleAuthorDetailsContent\n  ...articleBaseAdvertisingInfoArticle\n  ...articleCommentsTriggerArticle\n  ...articleImageGalleryContent\n  ...articleLeadingArticle\n  ...articleLeftHandSideWidgetsContent\n  ...articleLinkingDataContent\n  ...articleMoreOnThisListArticle\n  ...articleSectionsContent\n  ...articleShareWidgetArticle\n  ...articleSponsorContent\n  ...articleTopicFollowWidgetArticle\n  ...articleTopicsContent\n  ...articleVocabBoxArticle\n  ...contentBodyContent_4oKxOH\n  ...contentHeadlineContent\n  ...contentSchemaRenderContent\n  ...contentSubHeadlineContent\n  ...morningStudioArticleContent\n  ...newsletterArticleArticle\n  ...pianoIntegrationArticle\n  ...articleUtilsArticle\n  ...opinionArticleContent\n}\n\nfragment articleSchemaContent_2w8PNF on Query {\n  article(filter: {entityId: $entityId}) {\n    authorLocations\n    contentLock\n    createdDate\n    flag\n    headline\n    publishedDate\n    socialHeadline\n    sponsorType\n    updatedDate\n    urlAlias\n    authors {\n      location\n      name\n      types\n      urlAlias\n      id\n    }\n    body(customContents: $customContents) {\n      json\n      text\n    }\n    corrections {\n      correction {\n        text\n      }\n      timestamp\n    }\n    images {\n      isSlideshow\n      height\n      width\n      url\n    }\n    sections {\n      value {\n        name\n        id\n      }\n    }\n    types {\n      value {\n        name\n        id\n      }\n    }\n    id\n  }\n  ...liveBlogPostingLiveArticles_2w8PNF\n}\n\nfragment articleSectionsContent on Content {\n  __isContent: __typename\n  sections {\n    value {\n      ...helpersFilterSection\n      ...entityLink\n      name\n      id\n    }\n  }\n}\n\nfragment articleSeoArticle_4oKxOH on Article {\n  ...hooksArticleSeoArticle\n  entityId\n  publishedDate\n  updatedDate\n  headline\n  summary {\n    text\n  }\n  subHeadline {\n    text\n  }\n  body(customContents: $customContents) {\n    text\n  }\n  keywords\n  sections {\n    value {\n      name\n      id\n    }\n  }\n  topics {\n    name\n    entityId\n    id\n  }\n  urlAlias\n  authors {\n    name\n    id\n  }\n  images {\n    style(filter: {style: \"768x768\"}) {\n      url\n    }\n  }\n  copyrighted\n  entityUuid\n  socialHeadline\n  sponsor\n}\n\nfragment articleShareWidgetArticle on Article {\n  ...contentShareWidgetContent\n  ...articleCommentsTriggerArticle\n  urlAlias\n}\n\nfragment articleSponsorContent on Article {\n  topics {\n    entityId\n    sponsor {\n      description {\n        json\n      }\n      ...sponsorTagSponsor\n      id\n    }\n    id\n  }\n  ...hooksUseContentSponsorContent\n  ...helpersCheckIsMainTopicContent\n  ...contentSchemaRenderContent\n}\n\nfragment articleTopicFollowWidgetArticle on Article {\n  topics {\n    ...topicLinkTopic\n    ...entityFollowButtonBase\n    disableFollow\n    id\n  }\n}\n\nfragment articleTopicsContent on Content {\n  __isContent: __typename\n  topics {\n    ...topicLinkTopic\n    ...entityFollowButtonBase\n    entityId\n    id\n  }\n}\n\nfragment articleUtilsArticle on Article {\n  types {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment articleVocabBoxArticle on Article {\n  glossary {\n    term\n    translation\n    description {\n      json\n    }\n  }\n  ...contentSchemaRenderContent\n}\n\nfragment atomsCurrentArticleAtomBase_4oKxOH on Base {\n  __isBase: __typename\n  __typename\n  ... on Article {\n    ...articleSeoArticle_4oKxOH\n    ...contentShareWidgetContent\n    ...headerContentBookmarkArticle\n    ...headerContentCommentTrigger\n    ...helpersUseSharingUrl\n    ...hooksContentInterestArticle\n    ...hooksUseCurrentArticleIdsArticle\n    ...hooksUseNotificationReadStatusArticle\n    ...onboardingNewsletterSubscriptionArticle\n  }\n}\n\nfragment atomsCurrentNotificationSectionAtomBase on Base {\n  __isBase: __typename\n  __typename\n  ... on Section {\n    fullSectionPath {\n      ...hooksUseNotificationsSection\n      id\n    }\n  }\n  ... on Article {\n    sections {\n      value {\n        ...hooksUseNotificationsSection\n        id\n      }\n    }\n  }\n}\n\nfragment authorAvatarAuthor on Author {\n  ...entityLink\n  entityId\n  name\n  types\n  image(filter: {type: AUTHOR_IMAGE}) {\n    style(filter: {style: \"118x118\"}) {\n      url\n    }\n  }\n}\n\nfragment authorBioAuthor on Author {\n  bio\n}\n\nfragment authorCardAuthor on Author {\n  ...authorSocialLinksAuthor\n  ...authorAvatarAuthor\n  ...authorNameAuthor\n  ...authorBioAuthor\n  ...entityFollowButtonBase\n}\n\nfragment authorNameAuthor on Author {\n  ...entityLink\n  name\n}\n\nfragment authorNamesArticle on Article {\n  authorLocations\n  authors {\n    entityId\n    location\n    ...authorNameAuthor\n    id\n  }\n}\n\nfragment authorSocialLinksAuthor on Author {\n  socialLinks {\n    class\n    title\n    url\n  }\n}\n\nfragment blockquoteQuoteContent on Content {\n  __isContent: __typename\n  ...contentShareWidgetContent\n}\n\nfragment breadcrumbNewsletterArticleArticle on Article {\n  types {\n    value {\n      name\n      id\n    }\n  }\n}\n\nfragment contentBodyContent_4oKxOH on Content {\n  __isContent: __typename\n  body(customContents: $customContents) {\n    json\n  }\n  ...contentSchemaRenderContent\n}\n\nfragment contentHeadlineContent on Content {\n  __isContent: __typename\n  headline\n  socialHeadline\n  ...contentHeadlineTagContent\n}\n\nfragment contentHeadlineTagContent on Content {\n  __isContent: __typename\n  ...hooksContentHeadlineTagContent\n}\n\nfragment contentNewsletterWidgetContent on Content {\n  __isContent: __typename\n  topics {\n    relatedNewsletters {\n      ...helpersMassageToNewsletterItemNewsletter\n      id\n    }\n    id\n  }\n  sections {\n    value {\n      relatedNewsletters {\n        ...helpersMassageToNewsletterItemNewsletter\n        id\n      }\n      id\n    }\n  }\n  ... on Article {\n    relatedNewsletters {\n      ...helpersMassageToNewsletterItemNewsletter\n      id\n    }\n  }\n}\n\nfragment contentSchemaRenderContent on Content {\n  __isContent: __typename\n  ...scmpYoutubeContent\n  ...imageContent\n  ...blockquoteQuoteContent\n  ...inlineWidgetContent\n  ...photoGalleryWidgetContent\n}\n\nfragment contentShareWidgetContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  shortUrl\n  socialHeadline\n  headline\n}\n\nfragment contentSubHeadlineContent on Content {\n  __isContent: __typename\n  subHeadline {\n    json\n  }\n  ...contentSchemaRenderContent\n}\n\nfragment entityFollowButtonBase on Base {\n  __isBase: __typename\n  __typename\n  ... on Section {\n    entityId\n    name\n  }\n  ... on Author {\n    entityId\n    name\n    disableFollow\n  }\n  ... on Topic {\n    entityId\n    name\n    disableFollow\n  }\n}\n\nfragment entityLink on Base {\n  __isBase: __typename\n  __typename\n  entityId\n  entityUuid\n  urlAlias\n  urlRedirect {\n    toUrl\n    id\n  }\n  application {\n    entityId\n    id\n  }\n  ...helpersAppBarThemeArticle\n}\n\nfragment genericArticleFooterArticle on Article {\n  entityId\n}\n\nfragment headerContentBookmarkArticle on Article {\n  entityId\n  urlAlias\n}\n\nfragment headerContentCommentTrigger on Article {\n  ...articleCommentsTriggerArticle\n}\n\nfragment headerMorningStudioArticle on Article {\n  ...articleSponsorContent\n  ...subheaderMorningStudioSubheaderContent\n  headline\n  coverDesktop: image(filter: {type: COVER}) {\n    url\n  }\n  coverMobile: image(filter: {type: COVER_MOBILE}) {\n    url\n  }\n}\n\nfragment headerNewsletterArticleArticle on Article {\n  headline\n  ...issuesNewsletterArticleArticle\n  ...breadcrumbNewsletterArticleArticle\n}\n\nfragment headerOpinionArticle on Article {\n  types {\n    value {\n      name\n      description {\n        json\n      }\n      id\n    }\n  }\n  authors {\n    name\n    image(filter: {type: AUTHOR_IMAGE}) {\n      url\n    }\n    authorLarge: image(filter: {type: AUTHOR_LARGE}) {\n      url\n    }\n    id\n  }\n  ...contentSchemaRenderContent\n}\n\nfragment helpersAppBarThemeArticle on Article {\n  sponsorType\n  articleTypes: types {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersCheckIsMainTopicContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    id\n  }\n}\n\nfragment helpersFilterSection on Section {\n  name\n}\n\nfragment helpersIsArchiveWallArticle on Article {\n  ...helpersIsVelocityWallArticle\n  createdDate\n  publishedDate\n  paywallTypes {\n    entityId\n    id\n  }\n}\n\nfragment helpersIsVelocityWallArticle on Article {\n  paywallTypes {\n    entityId\n    id\n  }\n}\n\nfragment helpersMassageToNewsletterItemNewsletter on Newsletter {\n  entityId\n  name\n  alternativeName\n  description {\n    text\n  }\n  summary {\n    text\n  }\n  homepageDescription {\n    text\n  }\n}\n\nfragment helpersUseSharingUrl on Content {\n  __isContent: __typename\n  urlAlias\n}\n\nfragment hooksArticleSeoArticle on Article {\n  entityId\n  flag\n  knowledgeQuestion\n  headline\n  socialHeadline\n  summary {\n    text\n  }\n  types {\n    value {\n      entityId\n      id\n    }\n  }\n  topics {\n    sponsor {\n      entityId\n      id\n    }\n    id\n  }\n  sections {\n    value {\n      entityId\n      id\n    }\n  }\n  images {\n    generic_og: style(filter: {style: \"og_image_scmp_generic\"}) {\n      url\n    }\n    styles(filter: {styles: [\"og_image_scmp_analysis\", \"og_image_scmp_explainer\", \"og_image_scmp_fact_check\", \"og_image_scmp_debate\", \"og_image_scmp_live\", \"og_image_scmp_obituary\", \"og_image_scmp_opinion\", \"og_image_scmp_review\", \"og_image_scmp_series\", \"og_image_scmp_generic\"]}) {\n      url\n      style\n    }\n    type\n  }\n  disableOffPlatformContent\n  published\n  sponsorType\n  urlAlias\n}\n\nfragment hooksContentHeadlineTagContent on Content {\n  __isContent: __typename\n  ...hooksContentHelperContent\n  ... on Article {\n    types {\n      value {\n        name\n        entityId\n        description {\n          text\n        }\n        id\n      }\n    }\n  }\n  flag\n  sections {\n    value {\n      name\n      id\n    }\n  }\n}\n\nfragment hooksContentHelperContent on Content {\n  __isContent: __typename\n  ... on Article {\n    types {\n      value {\n        entityId\n        id\n      }\n    }\n  }\n  authors {\n    entityId\n    types\n    id\n  }\n  flag\n}\n\nfragment hooksContentInterestArticle on Article {\n  entityId\n  sentiment\n  urlAlias\n  types {\n    value {\n      name\n      id\n    }\n  }\n  topics {\n    name\n    id\n  }\n}\n\nfragment hooksPaywallPromiseArticle on Article {\n  entityId\n}\n\nfragment hooksTrackCurrentItemBase_4oKxOH on Base {\n  __isBase: __typename\n  __typename\n  ...atomsCurrentArticleAtomBase_4oKxOH\n  ...atomsCurrentNotificationSectionAtomBase\n}\n\nfragment hooksUseContentSponsorContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    sponsor {\n      ...sponsorTagSponsor\n      name\n      type\n      id\n    }\n    id\n  }\n  ... on Article {\n    sponsorType\n  }\n  ...helpersCheckIsMainTopicContent\n}\n\nfragment hooksUseCurrentArticleIdsArticle on Article {\n  entityId\n  entityUuid\n}\n\nfragment hooksUseNotificationReadStatusArticle on Article {\n  entityId\n}\n\nfragment hooksUseNotificationsSection on Section {\n  ...notificationSection\n  entityId\n}\n\nfragment imageContent on Content {\n  __isContent: __typename\n  headline\n}\n\nfragment inlineWidgetContent on Content {\n  __isContent: __typename\n  ...contentNewsletterWidgetContent\n}\n\nfragment issuesDropdownNewsletterArticleArticle on Article {\n  entityId\n}\n\nfragment issuesNewsletterArticleArticle on Article {\n  types {\n    value {\n      entityUuid\n      id\n    }\n  }\n  ...issuesDropdownNewsletterArticleArticle\n}\n\nfragment liveBlogPostingLiveArticles_2w8PNF on Query {\n  article(filter: {entityId: $entityId}) {\n    urlAlias\n    id\n  }\n  liveArticle(filter: {entityUuid: $entityUuid}) {\n    customTimezone\n    liveContents {\n      entityId\n      publishedDate\n      title\n      body {\n        text\n      }\n    }\n    id\n  }\n}\n\nfragment morningStudioArticleContent on Content {\n  __isContent: __typename\n  ...headerMorningStudioArticle\n}\n\nfragment morningStudioArticleFooterContent on Content {\n  __isContent: __typename\n  entityUuid\n  topics {\n    entityUuid\n    id\n  }\n}\n\nfragment newsletterArticleArticle on Article {\n  ...headerNewsletterArticleArticle\n  ...issuesNewsletterArticleArticle\n}\n\nfragment notificationSection on Section {\n  name\n}\n\nfragment onboardingNewsletterSubscriptionArticle on Article {\n  sections {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment opinionArticleContent on Content {\n  __isContent: __typename\n  ...headerOpinionArticle\n  ...hooksContentHelperContent\n  ...contentSchemaRenderContent\n}\n\nfragment photoGalleryDialogContent on Content {\n  __isContent: __typename\n  __typename\n  ...contentShareWidgetContent\n}\n\nfragment photoGalleryWidgetContent on Content {\n  __isContent: __typename\n  ...photoGalleryDialogContent\n}\n\nfragment pianoIntegrationArticle on Article {\n  __typename\n  contentLock\n  createdDate\n  entityId\n  entityUuid\n  headline\n  publishedDate\n  sponsor\n  sponsorType\n  urlAlias\n  authors {\n    name\n    id\n  }\n  sections {\n    value {\n      entityUuid\n      name\n      id\n    }\n  }\n  topics {\n    name\n    id\n  }\n  types {\n    value {\n      entityId\n      name\n      id\n    }\n  }\n  ...hooksPaywallPromiseArticle\n  ...helpersAppBarThemeArticle\n  ...helpersIsArchiveWallArticle\n  ...helpersIsVelocityWallArticle\n}\n\nfragment scmpYoutubeContent on Content {\n  __isContent: __typename\n  urlAlias\n  publishedDate\n}\n\nfragment seriesWidgetContent on Article {\n  ...seriesWidgetEntrypointHeadlineContent\n  entityId\n  seriesContainer {\n    ...entityLink\n    headline\n    series {\n      __typename\n      ... on Article {\n        ...seriesWidgetItemContent\n        entityId\n        id\n      }\n      ... on Podcast {\n        id\n      }\n      ... on Video {\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment seriesWidgetEntrypointHeadlineContent on Article {\n  entityId\n  seriesContainer {\n    ...entityLink\n    entityId\n    headline\n    series {\n      __typename\n      ... on Article {\n        entityId\n        id\n      }\n      ... on Podcast {\n        id\n      }\n      ... on Video {\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment seriesWidgetItemContent on Article {\n  ...entityLink\n  headline\n  socialHeadline\n  seriesContainer {\n    headline\n    id\n  }\n  images {\n    title\n    url\n    isSlideshow\n    style(filter: {style: \"237x147\"}) {\n      url\n    }\n  }\n}\n\nfragment sponsorTagSponsor on Sponsor {\n  name\n  type\n  images {\n    url\n  }\n}\n\nfragment subheaderMorningStudioSubheaderContent on Content {\n  __isContent: __typename\n  ...articleShareWidgetArticle\n  ...articleSponsorContent\n}\n\nfragment topPicksWidgetContent on Article {\n  entityId\n}\n\nfragment topicLinkTopic on Topic {\n  ...entityLink\n  name\n}\n"
  }
};
})();

(node as any).hash = "a51d5518545badaf5e40641963efec01";

export default node;
